module.exports = __webpack_public_path__ + "img/CO.c6ab25be.png";